export default "/images/video-online.png?a07efe3d548cd8470f42a0d41d19bdab";